import { Map, fromJS } from 'immutable';

export function request(state, { userId, leg }) {
    let userLegs = state.getIn([ 'legs', userId ]) || Map();

    state = state.set(
        'legs',
        state.get('legs').set(
            userId,
            userLegs.set(leg.uid, fromJS(leg))
        )
    );

    return state;
}
